import {
    Container, CardHeader, AvatarWrapper, HeaderInfo,
    MeetingTitle, Username, Description,
    CardFooter, TagsContainer, Tag, FreeTag, PriceTag, OwnerBadge,
} from "./Style";
import { Avatar, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useNavigate } from "react-router-dom";
import { getServerNow } from "../../hooks/useServerTime";

const MeetingCard = ({ picture, title, user, description, free, pricing, privacy, raffle, dates, id, isOwner, topics }) => {
    const navigation = useNavigate();
    // Relogio do servidor, nao o do aparelho: com o celular adiantado os
    // horarios que ainda estao por vir sumiam so no celular
    const now = getServerNow();

    // Filtrar horarios: futuros e nao comprados (para agendamento)
    // Para sorteio: futuros (purchased nao importa pois varios podem comprar)
    const availableDates = (dates || []).filter(d => {
        if (!d.datetime) return false;
        const dt = new Date(d.datetime);
        if (dt < now) return false; // Ja passou
        if (!raffle && d.purchased) return false; // Ja comprado (agendamento)
        return true;
    });

    // Se nao tem horarios disponiveis, nao exibir o card (a menos que seja do proprio anfitriao)
    if (availableDates.length === 0 && !isOwner) return null;

    const handleClick = () => {
        // O anfitriao vai direto para o acompanhamento do proprio encontro, em
        // vez da tela de compra, que nao faz sentido para ele
        if (isOwner) return navigation(`/meus-encontros/${id}/horarios`);
        navigation(`/encontrar/${id}/detalhes`);
    };

    return (
        <Container onClick={handleClick}>
            {isOwner && <OwnerBadge>Meu encontro</OwnerBadge>}

            <CardHeader>
                <AvatarWrapper>
                    {picture
                        ? <img src={picture} alt={user} />
                        : <Avatar sx={{ width: 42, height: 42, bgcolor: '#ddd' }}>
                            <PersonIcon sx={{ fontSize: 24, color: '#fff' }} />
                        </Avatar>
                    }
                </AvatarWrapper>
                <HeaderInfo>
                    <MeetingTitle>{title}</MeetingTitle>
                    <Username>Anfitrião: @{user}</Username>
                </HeaderInfo>
            </CardHeader>

            <Description>{description}</Description>

            <CardFooter>
                <TagsContainer>
                    {free
                        ? <FreeTag>Gratuito</FreeTag>
                        : pricing > 0 && <PriceTag>R$ {Number(pricing).toFixed(2).replace('.', ',')}</PriceTag>
                    }
                    <Tag>{privacy ? 'Publico' : 'Privado'}</Tag>
                    <Tag>{raffle ? 'Sorteio' : 'Agendamento'}</Tag>
                </TagsContainer>
            </CardFooter>

            {/* Tags do encontro */}
            {topics?.length > 0 && (
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ px: '18px', py: '10px', borderTop: '1px solid #f2f2f2' }}>
                    {topics.map((t, i) => (
                        <Typography key={t.Topic?.id || i} variant="caption" sx={{ fontSize: '0.65rem', color: '#555', bgcolor: '#f0f0f0', borderRadius: '4px', px: 0.8, py: 0.2 }}>
                            {t.Topic?.name}
                        </Typography>
                    ))}
                </Stack>
            )}

            {/* Horarios disponiveis */}
            {availableDates.length > 0 && (
                <Stack spacing={0.5} sx={{ px: '18px', pb: '14px' }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 600 }}>
                        {availableDates.length} horario{availableDates.length > 1 ? 's' : ''} disponive{availableDates.length > 1 ? 'is' : 'l'}
                    </Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                        {availableDates.slice(0, 4).map((d, i) => {
                            const dt = new Date(d.datetime);
                            const day = dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
                            const time = dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                            return (
                                <Stack key={i} direction="row" alignItems="center" spacing={0.3}
                                    sx={{ bgcolor: '#f5f5f5', borderRadius: '6px', px: 0.8, py: 0.3 }}
                                >
                                    <AccessTimeIcon sx={{ fontSize: 11, color: '#999' }} />
                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666', whiteSpace: 'nowrap' }}>
                                        {day} {time}
                                    </Typography>
                                </Stack>
                            );
                        })}
                        {availableDates.length > 4 && (
                            <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#006a61', fontWeight: 500, alignSelf: 'center' }}>
                                +{availableDates.length - 4} mais
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            )}
        </Container>
    );
};

export default MeetingCard;
